<div class="app-titulo-pagina-v2">
    <img src="../../../assets/img/icons/bt_sac.png" alt="Icone btn_sac">
    <span>SAC - Meus Chamados</span>
</div>

<a (click)="mainService.loginService.changeRoute('/sac/form')" 
    id="btn-novo-chamado"
    class="btn app-btn-best">
    <i class="fa fa-plus-circle"></i> Novo chamado
</a>

<div *ngIf="mainService.sacService.processando"
     class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<input id="length-tabela-sac" type="hidden" value="{{mainService.sacService.chamados?.length}}">

<div *ngIf="mainService.sacService.chamados != undefined && mainService.sacService.chamados != 0"
     class="table-responsive">
    <table class="table table-striped table-hover">
        <thead>
            <tr>
                <th><span class="glyphicon glyphicon-arrow-down"></span> Protocolo</th>
                <th>Data</th>
                <th>Status</th>
                <th>Assunto</th>
                <th>Ações</th>
            </tr>
        </thead>
        <tbody id="tabelaSacBody">
            <tr *ngFor="let chamado of this.mainService.sacService.chamados">
                <td>{{ chamado.dataRegistro| dateFormat:'':'yyyy' }}{{ '-'+ chamado.id }}</td>
                <td>{{ chamado.dataRegistro| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ chamado.status}} <span class="badge"
                                            *ngIf="chamado.quantidadeMensagensNaoLidas > 0">{{ chamado.quantidadeMensagensNaoLidas }}</span></td>
                <td>{{ chamado.assunto }}</td>
                <td>
                    <button (click)="this.mainService.sacService.visualizarChamado(chamado)"
                            class="btn app-btn-best">
                        <i class="fa fa-eye"></i> visualizar
                    </button>
                    <button (click)="this.mainService.sacService.visualizarAnexos(chamado)"
                            class="btn app-btn-best">
                        <i class="fa fa-paperclip"></i> anexos
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/sac.component.html